import { render } from "./Properties.vue?vue&type=template&id=3567c250&ts=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"

import "./Properties.vue?vue&type=style&index=0&id=3567c250&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__